import Text from "@/shared/typography/text";
import { Link } from "react-router-dom";
import { NavigationItem } from "../model/types";
import { ItemType } from "antd/lib/menu/interface";
import { useTranslations } from "use-intl";

type T = ReturnType<typeof useTranslations>;

export function itemsToMenuItems(items: NavigationItem[], t: T) {
  return items.map((item) => transformItem(item, t));
}

function transformItem(
  item: NavigationItem,
  t: T,
): ItemType & { "data-testid"?: string } {
  const dataTestId = `navigation-item-${item.label}`;

  const labelText = (
    <Text as="span" type="body2" color="inherit">
      {t(item.label)}
    </Text>
  );

  if (item.children && item.children.length === 1) {
    return transformItem(item.children[0], t);
  }

  if (item.children) {
    return {
      label: labelText,
      key: item.key ?? item.label,
      icon: item.icon,
      children: item.children.map((child) => transformItem(child, t)),
      "data-testid": dataTestId,
    };
  }

  const a = {
    label: <Link to={item.to ?? "/TODO"}>{labelText}</Link>,
    key: item.key ?? item.label,
    icon: item.icon,
    "data-test": dataTestId,
  };

  return a;
}
